/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { PromptTypeEnum } from "./PromptTypeEnum";
import { EnvironmentId } from "../../commons/types/EnvironmentId";
import { SpaceId } from "../../commons/types/SpaceId";
export const PromptCreate = core.serialization.object({
    promptType: PromptTypeEnum.optional(),
    prompt: core.serialization.string(),
    environmentId: EnvironmentId,
    spaceId: SpaceId,
});
